module.exports = __webpack_public_path__ + "static/media/dashboard.d1f98233.svg";